import { LANGUAGE } from "@/common/utils/constants.js";

export const CLIENT_RESULT_DOCX = {
	[LANGUAGE.en.short]: {
		title: `Client Results`
	},
	[LANGUAGE.de.short]: {
		title: `Kundenergebnisse`,
	},
	[LANGUAGE.fr.short]: {
		title: `Résultats clients`
	},
	[LANGUAGE.it.short]: {
		title: `Risultati del cliente`
	},
	[LANGUAGE.ja.short]: {
		title: `クライアントの結果`
	},
	[LANGUAGE.es.short]: {
		title: `Resultados del cliente`
	}
}
